import React, { useContext, useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { server } from "../../common";
import { useFormik } from "formik";
import configContext from "../../context/configContext/configContext";
import * as Yup from "yup";
import { toast } from "react-toastify";

const initialValues = {
  fullname: "",
  mobile: "",
  image: null,
  wpnumber: "",
  dob: "",
  bloodgroup: "",
  state: "",
  district: "",
  taluka: "",
  village: "",
  wardno: "",
  address: "",
  permenent_adress: "",
  nooffamilymember: "",
  occupation: "",
  companyname: "",
  officeaddress: "",
  officetype: "",
  services: "",
  officePhone: "",
  jobcompanyname: "",
  jobposition: "",
  hobby: "",
  reference: "",
};

const MembershipRegistration = () => {
  // const user = useSelectAccess("Student");
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      fullname: Yup.string().required("कृपया पूर्ण नाव प्रविष्ट करा"),
      mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "कृपया वैध भारतीय मोबाईल क्रमांक टाका")
        .required("कृपया श्रेणी निवडा"),
      wpnumber: Yup.string().required("कृपया whatsapp नंबर एंटर करा"),
      dob: Yup.string().required("कृपया जन्मतारीख एंटर करा"),
      bloodgroup: Yup.string().required("कृपया रक्तगट एंटर करा"),
      state: Yup.string().required("कृपया राज्य टाका"),
      district: Yup.string().required("कृपया जिल्हा एंटर करा"),
      taluka: Yup.string().required("कृपया तालुका एंटर करा"),
      village: Yup.string().required("कृपया गाव एंटर करा"),
      wardno: Yup.string().required("कृपया वॉर्ड नंबर एंटर करा"),
      address: Yup.string().required("कृपया तात्पुरता पत्ता एंटर करा"),
      reference: Yup.string().required("कृपया तात्पुरता पत्ता एंटर करा"),
      permenent_adress: Yup.string().required("कृपया कायमचा पत्ता एंटर करा"),
      nooffamilymember: Yup.string().required(
        "कृपया कुटुंबातील सदस्यांची संख्या प्रविष्ट करा"
      ),
      occupation: Yup.string().required("कृपया व्यवसाय प्रविष्ट करा"),
      companyname: Yup.string().when("occupation", {
        is: "Business",
        then: (schema) => schema.required("Certificate 7/12 is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      officeaddress: Yup.string().when("occupation", {
        is: "Business",
        then: (schema) =>
          schema.required("कृपया कार्यालयाचा पत्ता प्रविष्ट करा"),
        otherwise: (schema) => schema.notRequired(),
      }),
      officetype: Yup.string().when("occupation", {
        is: "Business",
        then: (schema) => schema.required("कृपया कार्यालयाचा प्रकार निवडा"),
        otherwise: (schema) => schema.notRequired(),
      }),
      services: Yup.string().when("occupation", {
        is: "Business",
        then: (schema) => schema.required("कृपया सेवा/उत्पादने प्रविष्ट करा"),
        otherwise: (schema) => schema.notRequired(),
      }),
      officePhone: Yup.string().when("occupation", {
        is: "Business",
        then: (schema) =>
          schema.required("कृपया कार्यालयाचा फोन क्रमांक प्रविष्ट करा"),
        otherwise: (schema) => schema.notRequired(),
      }),
      jobcompanyname: Yup.string().when("occupation", {
        is: "Job",
        then: (schema) => schema.required("कृपया कंपनीचे नाव प्रविष्ट करा"),
        otherwise: (schema) => schema.notRequired(),
      }),
      jobposition: Yup.string().when("occupation", {
        is: "Job",
        then: (schema) => schema.required("कृपया पदनाम प्रविष्ट करा"),
        otherwise: (schema) => schema.notRequired(),
      }),
      image: Yup.mixed()
        .required("कृपया फोटो निवडा")
        .test("fileSize", "फाइलचा आकार खूप मोठा आहे", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      setProcessing(true);
      setProgress(10);
      if (!values.image) {
        toast.error("Please select a images");
        return;
      }
      const formData = new FormData();
      formData.append("fullname", values.fullname);
      formData.append("mobile", values.mobile);
      formData.append("wpnumber", values.wpnumber);
      formData.append("dob", values.dob);
      formData.append("bloodgroup", values.bloodgroup);
      formData.append("state", values.state);
      formData.append("district", values.district);
      formData.append("taluka", values.taluka);
      formData.append("village", values.village);
      formData.append("wardno", values.wardno);
      formData.append("address", values.address);
      formData.append("permenent_adress", values.permenent_adress);
      formData.append("nooffamilymember", values.nooffamilymember);
      formData.append("occupation", values.occupation);
      formData.append("companyname", values.companyname);
      formData.append("officeaddress", values.officeaddress);
      formData.append("officetype", values.officetype);
      formData.append("services", values.services);
      formData.append("officePhone", values.services);
      formData.append("reference", values.reference);
      formData.append("jobcompanyname", values.jobcompanyname);
      formData.append("jobposition", values.jobposition);
      formData.append("hobby", values.hobby);
      formData.append("image", values.image);

      server
        .post("/membership/addmembership", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: user.authToken,
          },
        })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            toast.success("Request Sent successfully");
            formik.resetForm();
            setProgress(100);
          }
          setProcessing(false);
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
          setProcessing(false);
          setProgress(100);
        });
    },
  });

  return (
    <div className="container py-5">
      {console.log(formik.values)}
      {console.log(formik.errors)}

      <Card className="shadow-lg p-3">
        <CardContent>
          <Typography variant="h4" className="text-center mb-4 fw-bold">
            Membership Registration Form <br /> सदस्य नोंदणी फॉर्म
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Full Name / पूर्ण नाव"
                  name="fullname"
                  fullWidth
                  value={formik.values.fullname}
                  onChange={formik.handleChange}
                />
                {formik.errors.fullname ? (
                  <p className="text-danger">{formik.errors.fullname}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="WhatsApp Number / व्हाट्सअँप नंबर"
                  name="wpnumber"
                  fullWidth
                  value={formik.values.wpnumber}
                  onChange={formik.handleChange}
                />
                {formik.errors.wpnumber ? (
                  <p className="text-danger">{formik.errors.wpnumber}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Mobile Number / मोबाइल"
                  name="mobile"
                  fullWidth
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                />
                {formik.errors.mobile ? (
                  <p className="text-danger">{formik.errors.mobile}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <label htmlFor=""> Photo / फोटो</label>
                <input
                  accept="image/*"
                  type="file"
                  name="image"
                  onChange={(event) => {
                    formik.setFieldValue("image", event.currentTarget.files[0]);
                  }}
                  className="form-control"
                />
                {formik.errors.photo ? (
                  <p className="text-danger">{formik.errors.photo}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  type="date"
                  name="dob"
                  fullWidth
                  label="Date of Birth / जन्मतारीख"
                  InputLabelProps={{ shrink: true }}
                  value={formik.values.dob}
                  onChange={formik.handleChange}
                />
                {formik.errors.dob ? (
                  <p className="text-danger">{formik.errors.dob}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Blood Group / रक्तगट"
                  name="bloodgroup"
                  fullWidth
                  value={formik.values.bloodgroup}
                  onChange={formik.handleChange}
                />
                {formik.errors.bloodgroup ? (
                  <p className="text-danger">{formik.errors.bloodgroup}</p>
                ) : null}
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Temporary Address / सध्याचा पत्ता"
                  name="address"
                  fullWidth
                  multiline
                  rows={2}
                  value={formik.values.address}
                  onChange={formik.handleChange}
                />
                {formik.errors.address ? (
                  <p className="text-danger">{formik.errors.address}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Ward/Prabhag No./ प्रभाग क्रमांक"
                  name="wardno"
                  fullWidth
                  value={formik.values.wardno}
                  onChange={formik.handleChange}
                />
                {formik.errors.wardno ? (
                  <p className="text-danger">{formik.errors.wardno}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} xs={6}>
                <TextField
                  label="Permanent Address / कायमस्वरूपी पत्ता"
                  name="permenent_adress"
                  fullWidth
                  multiline
                  rows={2}
                  value={formik.values.permenent_adress}
                  onChange={formik.handleChange}
                />
                {formik.errors.permenent_adress ? (
                  <p className="text-danger">
                    {formik.errors.permenent_adress}
                  </p>
                ) : null}
              </Grid>{" "}
              <Grid item xs={12} md={6}>
                <TextField
                  label="State / राज्य"
                  name="state"
                  fullWidth
                  value={formik.values.state}
                  onChange={formik.handleChange}
                />
                {formik.errors.state ? (
                  <p className="text-danger">{formik.errors.state}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="District / जिल्हा"
                  name="district"
                  fullWidth
                  value={formik.values.district}
                  onChange={formik.handleChange}
                />
                {formik.errors.district ? (
                  <p className="text-danger">{formik.errors.district}</p>
                ) : null}
              </Grid>{" "}
              <Grid item xs={12} md={6}>
                <TextField
                  label="Taluka / तालुका"
                  name="taluka"
                  fullWidth
                  value={formik.values.taluka}
                  onChange={formik.handleChange}
                />
                {formik.errors.taluka ? (
                  <p className="text-danger">{formik.errors.taluka}</p>
                ) : null}
              </Grid>{" "}
              <Grid item xs={12} md={6}>
                <TextField
                  label="Birth Village / जन्मगाव"
                  name="village"
                  fullWidth
                  value={formik.values.village}
                  onChange={formik.handleChange}
                />
                {formik.errors.village ? (
                  <p className="text-danger">{formik.errors.village}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="No. of Family Members / कुटुंबातील सदस्यांची संख्या"
                  name="nooffamilymember"
                  fullWidth
                  value={formik.values.nooffamilymember}
                  onChange={formik.handleChange}
                />
                {formik.errors.nooffamilymember ? (
                  <p className="text-danger">
                    {formik.errors.nooffamilymember}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel>Business / Job / व्यवसाय/नोकरी</InputLabel>
                  <Select
                    name="occupation"
                    value={formik.values.occupation}
                    onChange={formik.handleChange}
                  >
                    <MenuItem value="Business">Business</MenuItem>
                    <MenuItem value="Job">Job</MenuItem>
                  </Select>
                </FormControl>
                {formik.errors.occupation ? (
                  <p className="text-danger">{formik.errors.occupation}</p>
                ) : null}
              </Grid>
              {formik.values.occupation === "Business" && (
                <>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Company Name / कंपनीचे नाव"
                      name="companyname"
                      fullWidth
                      value={formik.values.companyname}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.companyname ? (
                      <p className="text-danger">{formik.errors.companyname}</p>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Office Address / पत्ता"
                      name="officeaddress"
                      fullWidth
                      value={formik.values.officeaddress}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.officeaddress ? (
                      <p className="text-danger">
                        {formik.errors.officeaddress}
                      </p>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Type / व्यवसायाचा प्रकार "
                      name="officetype"
                      fullWidth
                      value={formik.values.officetype}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.officetype ? (
                      <p className="text-danger">{formik.errors.officetype}</p>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Services / सेवा"
                      name="services"
                      fullWidth
                      value={formik.values.services}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.services ? (
                      <p className="text-danger">{formik.errors.services}</p>
                    ) : null}
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <label htmlFor="">Office Photo / कार्यालयाचे फोटो</label>
                    <input
                      type="file"
                      name="officePhotos"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "officePhotos",
                          event.currentTarget.files[0]
                        );
                      }}
                      className="form-control"
                    />
                    {formik.errors.officePhotos ? (
                      <p className="text-danger">
                        {formik.errors.officePhotos}
                      </p>
                    ) : null}
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Office Phone Number / फोन नंबर(कार्यालय)"
                      name="officePhone"
                      fullWidth
                      value={formik.values.officePhone}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.officePhone ? (
                      <p className="text-danger">{formik.errors.officePhone}</p>
                    ) : null}
                  </Grid>
                </>
              )}
              {formik.values.occupation === "Job" && (
                <>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Company Name / कंपनीचे नाव"
                      name="jobcompanyname"
                      fullWidth
                      value={formik.values.jobcompanyname}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.jobcompanyname ? (
                      <p className="text-danger">
                        {formik.errors.jobcompanyname}
                      </p>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Position / पद"
                      name="jobposition"
                      fullWidth
                      value={formik.values.jobposition}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.jobposition ? (
                      <p className="text-danger">{formik.errors.jobposition}</p>
                    ) : null}
                  </Grid>
                </>
              )}
              <Grid item xs={6}>
                <TextField
                  label="Hobby / छंद"
                  name="hobby"
                  fullWidth
                  value={formik.values.hobby}
                  onChange={formik.handleChange}
                />
                
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Reference Name / संदर्भ नाव"
                  name="reference"
                  fullWidth
                  value={formik.values.reference}
                  onChange={formik.handleChange}
                />
                {formik.errors.reference ? (
                  <p className="text-danger">{formik.errors.reference}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} className="text-center">
                <Button variant="contained" color="primary" type="submit">
                  Submit Form
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default MembershipRegistration;
